import { config } from '@static/js/joy';
import { SegmentService } from '../analytics/segment/service';
import { Logger } from '../logging';
import { createApolloClient } from '../graphql/client';
import { LoginManager } from '../auth/loginManager';
import type { NormalizedCacheObject } from 'apollo-cache-inmemory';
import type { ApolloClient } from '@apollo/client';

export type SetupOverrides = Partial<{
  logger: Logger;
  apolloClient?: ApolloClient<NormalizedCacheObject>;
  loginManager?: LoginManager;
}>;

export const setup = (overrides: SetupOverrides = {}) => {
  // Create segment service
  const segment = new SegmentService();

  // Create logger
  const logger = overrides.logger || new Logger();

  // Use the provided LoginManager (e.g., SSR instance seeded with auth token) or create a new one.
  // During SSR, the LoginManager may be pre-seeded with auth secrets from the request cookie
  // so that AuthProvider can run the GetMe query eagerly during server rendering.
  // Note: Only a subset of SSR routes seed the LoginManager (currently only guest site routes
  // where useSsrAuthToken=true). When seeded, the SSR HTML output is user-specific and is
  // NOT cached (see htmlCache.ts). Other SSR routes receive a fresh, unseeded LoginManager.
  const loginManager = overrides.loginManager || new LoginManager(logger);

  // Create Graphql Client
  const apolloClient = overrides.apolloClient || createApolloClient({ loginManager, graphQLUrl: config.graphQLUrl });

  // Return all objects needed for <SetupComponent />
  return { logger, segment, apolloClient, config, loginManager };
};
